<template>
    <div class="create-order">
        <h3 class="title">Create order</h3>
        <div
            class="column"
            style="width: 100%;"
        >
            <div class="columns">
                <b-field
                    class="column is-12"
                    label="Order id"
                    label-position="inside"
                >
                    <b-input
                        size="is-small"
                        v-model="id"
                    ></b-input>
                </b-field>
            </div>
            <div class="columns">
                <b-field
                    class="column is-12"
                    label="Select a date"
                    label-position="inside"
                >
                    <b-datetimepicker
                        size="is-small"
                        v-model="datetime"
                        placeholder="Type or select a date..."
                        icon="calendar-today"
                        :timepicker="timepicker"
                        locale="en-US"
                    >
                    </b-datetimepicker>
                </b-field>
            </div>
            <div class="columns">
                <b-field
                    class="column is-12"
                    label="Customer Name"
                    label-position="inside"
                >
                    <b-input
                        size="is-small"
                        v-model="name"
                    ></b-input>
                </b-field>
            </div>
            <div class="columns">
                <b-field
                    class="column is-12"
                    label="Customer Phone number"
                    label-position="inside"
                >
                    <b-input
                        size="is-small"
                        v-model="phone"
                    ></b-input>
                </b-field>
            </div>
            <div class="columns">
                <b-field
                    class="column is-5"
                    label="Origin"
                    label-position="inside"
                >
                    <b-select
                        size="is-small"
                        placeholder="Select branch"
                        v-model="origin"
                    >
                        <option
                            v-for="option in branchs"
                            :value="option.name"
                            :key="option.name"
                        >
                            {{ option.name }}
                        </option>
                    </b-select>
                </b-field>
                <b-field
                    class="column is-7"
                    label="Destination"
                    label-position="inside"
                >
                    <b-input
                        size="is-small"
                        v-model="destination"
                        maxlength="200"
                        type="textarea"
                    ></b-input>
                </b-field>
            </div>
            <div class="columns">
                <b-field
                    class="column is-5"
                    label="Price"
                    label-position="inside"
                >
                    <b-input
                        size="is-small"
                        type="number"
                        v-model.number="price"
                    ></b-input>
                </b-field>
                <b-field
                    class="column is-7"
                    label="Product list"
                    label-position="inside"
                >
                    <b-input
                        size="is-small"
                        v-model="productlist"
                        maxlength="200"
                        type="textarea"
                    ></b-input>
                </b-field>
            </div>
            <div class="columns">
                <b-field
                    class="column is-5"
                    label="DeliveryFee"
                    label-position="inside"
                >
                    <b-input
                        size="is-small"
                        type="number"
                        v-model.number="deliveryFee"
                    ></b-input>
                </b-field>
            </div>
            <div style="text-align: right;">
                <b-button
                    @click="onGetDeliveryFee"
                    type="is-primary"
                >Create Order</b-button>
            </div>
        </div>
        <b-modal
            v-model="modalConfirm"
            :width="640"
            scroll="keep"
        >
            <div class="card">
                <div class="card-content">
                    <div class="media">
                        <div class="media-content">
                            <p
                                style="padding:0px"
                                class="title is-4"
                            >Delivery Fee</p>
                        </div>
                    </div>

                    <div
                        style="margin:0px"
                        class="columns is-multiline"
                    >
                        <div
                            style="padding:10px 0"
                            class="column is-half"
                        >
                            <h5 class="title-text">Branch:</h5>
                            <p>{{ origin }}</p>
                            <small>{{ branchAddress.address_th }}</small>
                        </div>
                        <div
                            style="padding:10px 0"
                            class="column is-half"
                        >
                            <h5 class="title-text">Destination:</h5>
                            <p>{{ destination }}</p>
                        </div>
                        <div
                            style="padding:10px 0"
                            class="column is-half"
                        >
                            <h5 class="title-text">Distance:</h5>
                            <p>{{ distance ? (distance/1000) : "NOT FOUND" }} KM.</p>
                        </div>
                        <div
                            style="padding:10px 0"
                            class="column is-half"
                        >
                            <h5 class="title-text">Delivery fee:</h5>
                            <p>{{ deliveryFee }} THB</p>
                        </div>
                    </div>
                </div>
            </div>
            <footer
                class="modal-card-foot"
                style="justify-content: flex-end;"
            >
                <b-button
                    label="Close"
                    @click="modalConfirm = false"
                />
                <b-button
                    @click="onclickCreate"
                    label="Create"
                    type="is-primary"
                />
            </footer>
        </b-modal>
    </div>
</template>

<script>
import branchs, { getBranchAddress } from "@/settings/branchs";
import dayjs from "dayjs";

export default {
  data() {
    return {
      id: null,
      branchs: branchs,
      name: null,
      phone: null,
      origin: "Sukhumvit 33",
      destination: "ซอย รามคำแหง 40 แขวง หัวหมาก เขตบางกะปิ กรุงเทพมหานคร 10240",
      datetime: new Date(),
      price: null,
      productlist: null,
      modalConfirm: false,
      distance: null,
      deliveryFee : 0,
      timepicker: {
        incrementMinutes: 60,
        enableSeconds: false,
        hourFormat: "24",
      },
      isPickup: false,
    };
  },
  computed: {
    orderList() {
      return this.$store.getters["orders/orders"];
    },
    branchAddress() {
      console.log(getBranchAddress(this.origin));
      return getBranchAddress(this.origin);
    },
  },
  watch: {
    modalConfirm() {
      if (!this.modalConfirm) {
        this.distance = null;
      }
    },
  },
  mounted() {
    // this.$store.dispatch("orders/getOrders");
  },
  methods: {
    async onclickCreate() {
      const date = dayjs(this.datetime).format("YYYY-MM-DD");
      const time = dayjs(this.datetime).format("HH:00");
      let orderDateId = await this.$store.dispatch("orders/getOrderDateId", {
        date: date,
        nStatus: "PROGRESS",
      });
      if (orderDateId === null) {
        orderDateId = await this.$store.dispatch("orders/createDate", {
          date: date,
          status: "PROGRESS",
        });
      }
      const order = {
        orderDateId: orderDateId,
        origin: this.origin,
        destination: this.destination,
        time: time,
        name: this.name,
        phone: this.phone,
        productlist: this.productlist,
        status: "PROGRESS",
        price: this.price,
        deliveryDate: date,
        deliveryFee: this.deliveryFee,
        riderType: null,
      };
      if (this.id) {
        order["id"] = this.id;
      }
      const response = await this.$store.dispatch("orders/createOrder", order);
      this.modalConfirm = false;
      console.log({response});
      if (response) {
        if(response.errors){
          this.$buefy.notification.open({
            message: `สร้างออเดอร์ไม่สำเร็จ หรือออเดอร์มีอยู่ในระบบแล้ว โปรดตรวจสอบ`,
            type: "is-danger",
            duration: 5000,
            queue: false,
          });
        }else{
          const notif = this.$buefy.notification.open({
            message: `สร้างออเดอร์เรียบร้อยแล้ว เลขออเดอร์ของคุณคือ ${response.data.createOrder.id} (กดปิดเพื่อคัดลอกเลขออเดอร์)`,
            type: "is-success",
            queue: false,
            indefinite: true,
          });
          notif.$on("close", () => {
            this.copyToClipboard(response.data.createOrder.id);
            this.$buefy.notification.open("คัดลอกเลขออเดอร์เรียบร้อยแล้ว!");
          });
        }
      } else {
        this.$buefy.notification.open({
          message: `สร้างออเดอร์ไม่สำเร็จ`,
          type: "is-danger",
          duration: 5000,
          queue: false,
        });
      }
    },
    copyToClipboard(text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    },
    async onGetDeliveryFee() {
      const destination = await this.$store.dispatch("delivery/getGeocode", {
        address: this.destination,
      });

      if (destination) {
        const location = {
          origin: { lat: this.branchAddress.latlng[0], lng: this.branchAddress.latlng[1] },
          destination: { lat: destination.lat, lng: destination.lng },
        };
        this.distance = await this.$store.dispatch("position/getDistance", {
          origin: location.origin,
          destination: location.destination,
        });
        // const mapOrigin = new window.google.maps.LatLng(location.origin.lat, location.origin.lng);
        // const mapDestination = new window.google.maps.LatLng(
        //   location.destination.lat,
        //   location.destination.lng
        // );
        // const service = new window.google.maps.DistanceMatrixService();
        try {
          // const res = await service.getDistanceMatrix({
          //   origins: [mapOrigin],
          //   destinations: [mapDestination],
          //   travelMode: "DRIVING",
          // });
          // console.log(res)
          const res = await this.$store.dispatch("delivery/getDistanceMatrix", {
            origins: String([location.origin.lat, location.origin.lng]),
            destinations: String([location.destination.lat, location.destination.lng]),
            travelMode: "DRIVING",
          });
          console.log(res);
          this.distance = res.rows[0].elements[0].distance.value;
        } catch (error) {
          console.log(error);
          this.distance = "XX";
        }
      }
      this.modalConfirm = true;
    },
    degreesToRadians(degrees) {
      return (degrees * Math.PI) / 180;
    },
    distanceInKmBetweenEarthCoordinates({ lat1, lon1, lat2, lon2 }) {
      var earthRadiusKm = 6371;

      var dLat = this.degreesToRadians(lat2 - lat1);
      var dLon = this.degreesToRadians(lon2 - lon1);

      lat1 = this.degreesToRadians(lat1);
      lat2 = this.degreesToRadians(lat2);

      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return earthRadiusKm * c;
    },
    // async onAcceptOrder(id) {xw
    //   if (!this.isPickup) {
    //     await this.$store.dispatch("orders/updateOrder", {
    //       orderId: id,
    //       status: "PICKUP",
    //       driverID: "MET",
    //     });
    //     this.isPickup = !this.isPickup;
    //   } else {
    //     await this.$store.dispatch("orders/updateOrder", {
    //       orderId: id,
    //       status: "DERIVERING",
    //     });
    //   }
    // },
    // async onDeleteOrder(order) {
    //   await this.$store.dispatch("orders/deleteOrder", order);
    // },
  },
};
</script>

<style scoped>
.title-text {
  margin: 0px !important;
  font-weight: bold;
}
p {
  margin: 0px !important;
}
.create-order {
  background-color: white;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title {
  padding: 10px;
  margin: 0;
  font-size: 24px;
  padding: 10px;
  margin: 0;
  position: sticky;
  top: 0px;
  background-color: white;
}
</style>
